import React, { Component } from 'react';
import LoadingBar from '../../components/global/loadingBar';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as UploadIcon } from '../../../assets/svg/upload-cloud.svg';
import InputHeader from '../../components/global/inputwithHeader';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import _ from 'lodash';
import UploadFilesForRemap from '../../components/adminTools/uploadFilesForRemap';

const remapEquipment = gql`
	mutation ReMapMemoryCard($type: String!, $newQrCode: String!, $oldQrCode: String) {
		reMapMemoryCard(type: $type, newQrCode: $newQrCode, oldQrCode: $oldQrCode) {
			message
		}
	}
`;
const getMemoryCard = gql`
	query MemoryCard($mcIdentifier: String) {
		memoryCard(mcIdentifier: $mcIdentifier) {
			branch {
				_id
				branchId
			}
			id
			qrCode
			ownerType
			ownerId
			type
			manufacturerId
			manufacturer
			description
			status
			createdAt
			updatedBy
			updatedAt
			size
			isReceived
			subStatus
		}
	}
`;
class RemapMemoryCard extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: false,
			newQrCode: '',
			oldQrCode: '',
			isMcFetching: false,
			qrCodeError: false,
			eqFetched: false,
			equipments: [],
			note: '',
			beforeFileCount: 0,
			afterFileCount: 0,
			uploadBeforeFiles: false,
			uploadAfterFiles: false,
			beforeFiles: [],
			afterFiles: [],
			isAPILoading: false,
		};
	}
	isDisabled = () => {
		if (
			this.state.newQrCode == '' ||
			this.state.oldQrCode == '' ||
			(this.state.newQrCode &&
				this.state.oldQrCode &&
				this.state.newQrCode === this.state.oldQrCode) ||
			this.state.newQrCode.length < 8 ||
			this.state.oldQrCode.length < 8 ||
			this.state.isAPILoading === true
		) {
			return true;
		} else {
			return false;
		}
	};
	handleRemapEquipment = () => {
		let json;
		json = {
			type: this.state.equipments[0].type,
			newQrCode: this.state.newQrCode,
			oldQrCode: this.state.oldQrCode,
		};
		this.remapEquipment(remapEquipment, json, 'mc');
	};
	handleQrCode = (e, type) => {
		if (type === 'oldQrCode') {
			this.setState({
				eqFetched: false,
				qrCodeError: false,
				isMcFetching: false,
			});
		}
		this.setState(
			{
				[type]: e.target.value,
			},
			async () => {
				if (type === 'oldQrCode' && e.target.value.length >= 8) {
					let json = { mcIdentifier: e.target.value };

					await this.getMemoryCardInfo(getMemoryCard, json, null, false);
					this.setState({ isMcFetching: false });
				}
			},
		);
	};

	updateFileCount = (count, type) => {
		this.setState({
			[`${type}FileCount`]: count,
		});
	};
	render() {
		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div
						className="assign-receive-container"
						style={{ width: '100%', marginLeft: 0 }}
					>
						<div className="arc-header">
							<div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div>
							<div className="arch-item">
								<span>Admin Tools</span>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>

							<div className="arch-item">
								<span>Remapping Memorycard</span>
							</div>
							<div className="actn-btn">
								<a
									onClick={(e) => {
										if (!this.isDisabled()) {
											/* this.setState({
												isAPILoading: true,
											}); */
											if (false && this.state.beforeFileCount > 0) {
												this.setState({ uploadBeforeFiles: true });
											} else if (false && this.state.afterFileCount > 0) {
												this.setState({ uploadAfterFiles: true });
											} else {
												this.handleRemapEquipment();
											}
										}
									}}
									className={this.isDisabled() ? 'isDisabledBtn' : ''}
								>
									Remap Memorycard
								</a>
							</div>
						</div>
						<div className="arc-body">
							<div className="remap-equipment-container">
								<div className="rec-left">
									<InputHeader
										type="text"
										name="oldQrCode"
										isInputError={false}
										label="Enter QR Code (old)"
										value={this.state.oldQrCode}
										width="100%"
										onChange={(e) => this.handleQrCode(e, 'oldQrCode')}
									/>

									{/* {this.state.oldQrCode !== '' &&
									this.state.qrCodeError !== true &&
									this.state.eqFetched ? ( */}
									<InputHeader
										type="text"
										name="newQrCode"
										isInputError={false}
										label="Enter QR Code (new)"
										value={this.state.newQrCode}
										width="100%"
										onChange={(e) => this.handleQrCode(e, 'newQrCode')}
									/>
									{/* ) : (
										''
									)} */}
									<div className="notes-container">
										<div className="notes-header">Notes</div>
										<textarea
											placeholder="Type here...."
											onChange={(e) =>
												this.setState({ note: e.target.value })
											}
											value={this.state.note}
										/>
									</div>
									<div className="remap-eq-summary">
										{this.state.isMcFetching === true ? (
											'Loading...'
										) : this.state.eqFetched === true ? (
											this.state.qrCodeError === false ? (
												<>
													<b>Old Qr Code Details:</b>
													<a>
														Description :{' '}
														<b>
															{this.state.equipments[0].description}
														</b>
													</a>
													<a>
														Manufacturer :{' '}
														<b>
															{this.state.equipments[0].manufacturer}
														</b>
													</a>
													<a>
														Status :{' '}
														<b>{this.state.equipments[0].status}</b>
													</a>
													<a>
														Type :{' '}
														<b>{this.state.equipments[0].type}</b>
													</a>
												</>
											) : (
												<p>Memorycard Not Found</p>
											)
										) : (
											''
										)}
									</div>
									{/* <InputHeader
										type="text"
										name="projectCode"
										isInputError={false}
										label="Notes"
										value={''}
										width="100%"
										textarea={true}
										rows={5}
									/> */}
								</div>
								<div className="rec-right">
									{/* <div className="remap-upload-outer">
										<div className="upload-header">BEFORE PHOTO</div>
										<div className="remap-upload-container">
											<span className="cloud-icn">
												<UploadIcon />
											</span>
											<span className="middle-text">
												Drag your images here
											</span>
											<span className="bottom-text">
												or Browse from your computer{' '}
											</span>
										</div>
									</div>
									<div className="remap-upload-outer">
										<div className="upload-header">AFTER PHOTO</div>
										<div className="remap-upload-container">
											<span className="cloud-icn">
												<UploadIcon />
											</span>
											<span className="middle-text">
												Drag your images here
											</span>
											<span className="bottom-text">
												or Browse from your computer{' '}
											</span>
										</div>
									</div> */}
									{/* <UploadFilesForRemap
										updateFileCount={(count) =>
											this.updateFileCount(count, 'before')
										}
										branchId={
											_.size(this.state.equipments) > 0 &&
											this.state.equipments[0].branch &&
											this.state.equipments[0].branch.branchId
												? this.state.equipments[0].branch.branchId
												: null
										}
										uploadTitle="BEFORE PHOTO"
										uploadFileCompleted={(files) =>
											this.uploadFileCompleted(files, 'before')
										}
										isLoading={this.state.isAPILoading}
										triggerFileUpload={this.state.uploadBeforeFiles}
									/>
									<UploadFilesForRemap
										updateFileCount={(count) =>
											this.updateFileCount(count, 'after')
										}
										branchId={
											_.size(this.state.equipments) > 0 &&
											this.state.equipments[0].branch &&
											this.state.equipments[0].branch.branchId
												? this.state.equipments[0].branch.branchId
												: null
										}
										uploadTitle="AFTER PHOTO"
										uploadFileCompleted={(files) =>
											this.uploadFileCompleted(files, 'after')
										}
										isLoading={this.state.isAPILoading}
										triggerFileUpload={this.state.uploadAfterFiles}
									/> */}
								</div>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}

export default withRouter(RemapMemoryCard);
